import { OpportunityFilter } from './opportunity-filter.model';

export class OpportunityRequest {
    producerCodes: Array<string>;
    page: number;
    pageSize: number;
    filters?: OpportunityFilter;
}
